import React, { Component } from 'react';
import { DDLoadingError } from '../globalPageStatus';
import { _anly_seng_custom } from '../../store/Action';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 上报错误日志
    _anly_seng_custom('error_boundary', {
      data: {
        err: error.toString(),
        info: errorInfo.componentStack.toString(),
      },
    });

    if (window._monitor_?.errorPlugin?.handleReactError) {
      window._monitor_.errorPlugin.handleReactError(error, errorInfo, this.props);
    }
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <DDLoadingError
          style={{ marginTop: 260 }}
          description="资源加载异常，请稍后再试"
          onRefresh={this.handleRefresh}
        />
      );
    }
    return this.props.children;
  }
}
